import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { QuillModule } from 'ngx-quill';
import { CourseDataTypeEnum } from '@edtech-ui/constants/course-types.enum';
import { ToastrService } from 'ngx-toastr';


@Component({
	selector: 'app-rte',
	standalone: true,
	imports: [MatIconModule, MatButtonModule, QuillModule, FormsModule, CommonModule],
	templateUrl: './rte.component.html',
	styleUrl: './rte.component.scss'
})
/**
 * @desc Rich Text Editor - Quill Editor
*/
export class RTEComponent implements OnInit {
	content: string = '';
	unitHours: string = '';
	CourseType=CourseDataTypeEnum;


	modules = {
		toolbar: [
			['bold', 'italic', 'underline', 'strike'],
			['blockquote', 'code-block'],
			[{ 'header': 1 }, { 'header': 2 }],
			[{ 'list': 'ordered' }, { 'list': 'bullet' }],
			[{ 'script': 'sub' }, { 'script': 'super' }],
			[{ 'indent': '-1' }, { 'indent': '+1' }],
			[{ 'direction': 'rtl' }],
			//  [{ 'size': QuillConfig.SIZE_WHITELIST }],
			[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
			[{ 'color': [] }, { 'background': [] }],
			[{ 'font': [] }],
			[{ 'align': [] }],
			['clean'],
		],
		clipboard: {
			matchers: [
				['img', () => {
					//  return new Delta();
				}]
			]
		}
	};

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { type: string, payload: any },
		@Optional() private dialogRef: MatDialogRef<RTEComponent> ,
		private _toastr :ToastrService,
	) { }

	ngOnInit() {
		switch (this.data.type) {
			case CourseDataTypeEnum.Objectives:
			case CourseDataTypeEnum.Outcome:
				this.content = (this.data.payload as string[]).map(item => `<p>${item}</p>`).join('');
				break;

			case CourseDataTypeEnum.Weblinks:
				this.content = (this.data.payload as string[]).map(link => `<p>${link}</p>`).join('');
				break;

			case CourseDataTypeEnum.Textbooks:
				this.content = (this.data.payload as any[]).map(book => {
				const { title, author, publisher, year } = book;
				return `<p>${title} by ${author}, ${publisher}, ${year}</p>`;}).join('');
				break;

			case CourseDataTypeEnum.Unit:
				this.content = `<p>${this.data.payload.unit_title}</p>`;
				this.unitHours = this.data.payload.unit_hours || '';
				break;

			case CourseDataTypeEnum.Topic:
				this.content = `<p>${this.data.payload.topic_title}</p>` + (this.data.payload.subtopics || [])
				 .map((sub: string) => `<p>${sub}</p>`).join('');
				break;

			case CourseDataTypeEnum.Code :
			case CourseDataTypeEnum.Course_Title :
				this.content = `<p>${this.data.payload}</p>`;
				break;

			case CourseDataTypeEnum.Course_Unit_Count :
			case CourseDataTypeEnum.Course_duration :
			case CourseDataTypeEnum.Resources :
				this.content = `<p>${this.data.payload}</p>`;
				break;

			default:
				this.content = '';
		}


	}

	closePostDialog(): void {
		this.dialogRef?.close();
	}

	save() {
		const div = document.createElement('div');
		div.innerHTML = this.content;

		const lines = Array.from(div.querySelectorAll('p, li, div, h1, h2, h3, h4, h5')).map(el => el.textContent?.trim() || '').filter(Boolean);

		switch (this.data.type) {
			case CourseDataTypeEnum.Objectives:
			case CourseDataTypeEnum.Outcome:
			case CourseDataTypeEnum.Weblinks:
				this.dialogRef?.close(lines);
				break;

			case CourseDataTypeEnum.Textbooks:
				const books = lines.map(line => {
					const [titlePart, rest] =  line.includes(' by ') ? line.split(' by ') :[line , ''];
					const [author = '' , publisher = '', year = ''] = (rest || '')
					.split(',').map(part => part?.trim());
					return {
						title: titlePart?.trim(),
						author, publisher, year
					};
				});
				this.dialogRef?.close(books);
				break;

			case CourseDataTypeEnum.Unit:
				const divUnit = document.createElement('div');
				divUnit.innerHTML = this.content;
				const titleUnit = divUnit.textContent?.trim() || '';
				
				const regex = /^([1-9][0-9]?)$/;
				if (this.unitHours && !regex.test(this.unitHours)) {
                this._toastr.error('Please enter hours as a number (e.g. 1, 2, 5)');
					return;
				}
				this.dialogRef?.close({ ...this.data.payload, unit_title: titleUnit, unit_hours: this.unitHours });
				break;

			case CourseDataTypeEnum.Topic:
				const divTopic = document.createElement('div');
				divTopic.innerHTML = this.content;
				const topicTitleElement = divTopic.querySelector('p');
				const topicTitle = topicTitleElement ? topicTitleElement.innerText.trim() : '';
				this.dialogRef?.close({ ...this.data.payload, topic_title: topicTitle || this.data.payload.topic_title,subtopics: [this.content]});
				break;

			case CourseDataTypeEnum.Code :
			case CourseDataTypeEnum.Course_Title:
			case CourseDataTypeEnum.Course_Unit_Count :
			case CourseDataTypeEnum.Course_duration :
			case CourseDataTypeEnum.Resources:
			    const text = lines[0] || '';
			    this.dialogRef?.close(text);
			    break;
		}
	}

}
